










import { computed, defineComponent, toRefs } from '@nuxtjs/composition-api'
import { useNamespacedStore } from '~/compositions/store'
import {
  CLASSIFIED_VIEW_NS,
  ClassifiedViewState
} from '~/store/modules/shared/classifieds/view/state'
import { TRADES_NS, TradesState } from '~/store/modules/shared/trades/state'

export default defineComponent({
  props: {
    inTrades: { type: Boolean, default: false }
  },
  setup(props) {
    const { inTrades } = toRefs(props)
    const { getters } = useNamespacedStore<ClassifiedViewState>(
      CLASSIFIED_VIEW_NS
    )

    let descriptionContent = computed(() => getters('getDescriptionContent'))
    if (inTrades.value) {
      const { state: tradesState } = useNamespacedStore<TradesState>(TRADES_NS)
      descriptionContent = computed(
        () => tradesState.classifiedDetails?.description?.content
      )
    }

    const isJobsClassified = computed(() => getters('isJobsClassified'))
    const isPlotClassified = computed(() => getters('isPlotClassified'))
    const isRentalClassified = computed(() => getters('isRentalClassified'))
    const isWantedPartsClassified = computed(() =>
      getters('isWantedPartsClassified')
    )

    const htmlDescription = computed(
      () =>
        isJobsClassified.value ||
        isPlotClassified.value ||
        isRentalClassified.value ||
        isWantedPartsClassified.value
    )

    return { descriptionContent, htmlDescription }
  }
})
